module.exports = __webpack_public_path__ + "img/breathing-not_so_good.a710d028.svg";